export const qaLabelTopBar = {
    profileIcon: 'top-bar--action-bar--profile-menu-caret',
    profileMenu: 'top-bar--action-bar--profile-menu',
    vromoLogo: 'top-bar--logo',
    actionMenu: {
        logOut: 'top-bar--action-bar--log-out'
    },
    rolePicker: 'top-bar--action-bar--role-picker'
};
